/**
 *  @param {Function} fn
 */
export default function contentLoaded(fn) {
  if (typeof fn !== 'function') { return; }

  if (document.readyState === 'complete') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  }
}
